const team = [
  { name: "Abhishek Sharma", role: "Founder & Wealth Manager", cred: "NISM & CRISIL Certified · AAFM Chartered Wealth Manager (Level-I)", bio: "Founder of Manigriv Financial Services. Leads client relationships, portfolio construction and financial planning end-to-end. Focused on transparent, fee-only advisory rooted in first-principles research." },
];

export default function Team() {
  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
      <div className="overline text-gold-dark mb-6">The people</div>
      <h1 className="font-display text-5xl md:text-6xl text-midnight tracking-tight mb-14">Small team, <span className="italic">deep bench</span>.</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-4xl">
        {team.map((t) => (
          <div key={t.name} className="bg-white rounded-2xl p-10 border border-black/5 shadow-[0_8px_30px_rgba(0,0,0,0.04)]">
            <div className="w-20 h-20 rounded-full bg-midnight text-gold flex items-center justify-center font-display text-3xl mb-6">{t.name[0]}</div>
            <h3 className="font-display text-2xl text-midnight">{t.name}</h3>
            <div className="text-sm text-midnight/60 mt-1">{t.role}</div>
            <div className="overline text-gold-dark mt-5 text-[10px] leading-relaxed">{t.cred}</div>
            <p className="text-sm text-midnight/70 mt-5 leading-relaxed">{t.bio}</p>
          </div>
        ))}
        <div className="bg-midnight text-white rounded-2xl p-10 flex flex-col justify-between">
          <div>
            <div className="overline text-gold mb-4">Hiring</div>
            <h3 className="font-display text-2xl mb-3">We're building the bench.</h3>
            <p className="text-sm text-white/70 leading-relaxed">Curious, quiet professionals who believe good advice compounds. If that sounds like you, we'd love to talk.</p>
          </div>
          <a href="/careers" className="btn-gold text-sm mt-6 inline-block w-fit">See open roles</a>
        </div>
      </div>
    </div>
  );
}
